module.exports = __webpack_public_path__ + "img/cq3d-banner.d42ad26b.png";